"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MultiPaneHeader = MultiPaneHeader;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FlexboxGrid = require("../containers/flexbox_layout/FlexboxGrid");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var HeaderWrapper = (0, _styledBase.default)("div", {
  target: "eloc4x80",
  label: "HeaderWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "19czrm7",
  styles: "max-width:1920px;padding:0 20px;margin:0 auto;clear:both;"
} : {
  name: "19czrm7",
  styles: "max-width:1920px;padding:0 20px;margin:0 auto;clear:both;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb21wb25lbnRzL011bHRpUGFuZUhlYWRlci9pbmRleC5qc3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBS2dDIiwiZmlsZSI6Ii4uLy4uL3NyYy9jb21wb25lbnRzL011bHRpUGFuZUhlYWRlci9pbmRleC5qc3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xyXG5pbXBvcnQgUHJvcFR5cGVzIGZyb20gJ3Byb3AtdHlwZXMnO1xyXG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XHJcbmltcG9ydCB7IEZsZXhSb3csIEdyaWQsIEJhc2VDb2wgfSBmcm9tICcuLi9jb250YWluZXJzL2ZsZXhib3hfbGF5b3V0L0ZsZXhib3hHcmlkJztcclxuXHJcbmNvbnN0IEhlYWRlcldyYXBwZXIgPSBzdHlsZWQuZGl2YFxyXG4gIG1heC13aWR0aDogMTkyMHB4O1xyXG4gIHBhZGRpbmc6IDAgMjBweDtcclxuICBtYXJnaW46IDAgYXV0bztcclxuICBjbGVhcjogYm90aDtcclxuYDtcclxuXHJcbmV4cG9ydCBmdW5jdGlvbiBNdWx0aVBhbmVIZWFkZXIoeyBjaGlsZHJlbiB9KSB7XHJcbiAgaWYgKGNoaWxkcmVuLmxlbmd0aCAhPT0gMikge1xyXG4gICAgdGhyb3cgRXJyb3IoJ0NvbnRlbnRIZWFkZXIgcmVxdWlyZXMgMiBjaGlsZHJlbjogbWFpbiwgYW5kIGFjdGlvbnMuJyk7XHJcbiAgfVxyXG5cclxuICBjb25zdCBbTWFpbiwgQWN0aW9uc10gPSBSZWFjdC5DaGlsZHJlbi50b0FycmF5KGNoaWxkcmVuKTtcclxuICBcclxuICBjb25zdCBtYWluQWxpZ25Qcm9wcyA9IHsgc206IDEyLCBtZDogNiwgYWxpZ246ICdsZWZ0JyB9O1xyXG4gIGNvbnN0IGFjdGlvbnNBbGlnblByb3BzID0geyBzbTogMTIsIG1kOiA2LCBwYWQ6IHsgbGVmdDogJ3NtYWxsJyB9LCBhbGlnbjogJ3JpZ2h0JyB9O1xyXG4gIHJldHVybiAoXHJcbiAgICA8SGVhZGVyV3JhcHBlcj5cclxuICAgICAgPEdyaWQ+XHJcbiAgICAgICAgPEZsZXhSb3c+XHJcbiAgICAgICAgICA8QmFzZUNvbCB7Li4ubWFpbkFsaWduUHJvcHN9PntSZWFjdC5jbG9uZUVsZW1lbnQoTWFpbil9PC9CYXNlQ29sPlxyXG4gICAgICAgICAgPEJhc2VDb2wgey4uLmFjdGlvbnNBbGlnblByb3BzfT57UmVhY3QuY2xvbmVFbGVtZW50KEFjdGlvbnMpfTwvQmFzZUNvbD5cclxuICAgICAgICA8L0ZsZXhSb3c+XHJcbiAgICAgIDwvR3JpZD5cclxuICAgIDwvSGVhZGVyV3JhcHBlcj5cclxuICApO1xyXG59XHJcblxyXG5NdWx0aVBhbmVIZWFkZXIucHJvcFR5cGVzID0ge1xyXG4gIGNoaWxkcmVuOiBQcm9wVHlwZXMuYXJyYXlPZihQcm9wVHlwZXMuZWxlbWVudCkuaXNSZXF1aXJlZFxyXG59O1xyXG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

function MultiPaneHeader(_ref) {
  var children = _ref.children;

  if (children.length !== 2) {
    throw Error('ContentHeader requires 2 children: main, and actions.');
  }

  var _React$Children$toArr = _react.default.Children.toArray(children),
      _React$Children$toArr2 = _slicedToArray(_React$Children$toArr, 2),
      Main = _React$Children$toArr2[0],
      Actions = _React$Children$toArr2[1];

  var mainAlignProps = {
    sm: 12,
    md: 6,
    align: 'left'
  };
  var actionsAlignProps = {
    sm: 12,
    md: 6,
    pad: {
      left: 'small'
    },
    align: 'right'
  };
  return /*#__PURE__*/_react.default.createElement(HeaderWrapper, null, /*#__PURE__*/_react.default.createElement(_FlexboxGrid.Grid, null, /*#__PURE__*/_react.default.createElement(_FlexboxGrid.FlexRow, null, /*#__PURE__*/_react.default.createElement(_FlexboxGrid.BaseCol, mainAlignProps, /*#__PURE__*/_react.default.cloneElement(Main)), /*#__PURE__*/_react.default.createElement(_FlexboxGrid.BaseCol, actionsAlignProps, /*#__PURE__*/_react.default.cloneElement(Actions)))));
}

MultiPaneHeader.propTypes = {
  children: _propTypes.default.arrayOf(_propTypes.default.element).isRequired
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@contently/toolkit/dist/MultiPaneHeader/index.js
// module id = 808
// module chunks = 0 15 16 17 18